import React from 'react'

const ApproveBookingDialogContext = React.createContext()

export default ApproveBookingDialogContext
